<template>
	<div class="main">
		<Header></Header>
		<section class="main-content">
			<h1>走进大马产品及项目登记</h1>
			<h2>我的产品/项目</h2>
			<van-radio-group v-model="radio">
				<div class="content-radio">
					<div class="radio-item">
						<van-radio name="2" icon-size="28px" checked-color="#DC394A" @click="selectRadio"></van-radio>
						<div class="text">希望进入大马市场</div>
					</div>
					<div class="radio-item">
						<van-radio name="1" icon-size="28px" checked-color="#DC394A" @click="selectRadio"></van-radio>
						<div class="text">希望进入中国市场</div>
					</div>
				</div>
			</van-radio-group>
			<div class="content-form">
				<div class="form-box">
					<div class="form-box_item">
						<div class="item-left">我的姓名:</div>
						<div class="item-right">
							<input type="text" placeholder="<请输入你的姓名>" v-model="name">
						</div>
					</div>
					<div class="form-box_item">
						<div class="item-left">我的手机号:</div>
						<div class="item-right">
							<input type="text" placeholder="<请输入你的手机>" v-model="phone">
						</div>
					</div>
					<div class="form-box_item">
						<div class="item-left">我的微信/WeChat号:</div>
						<div class="item-right">
							<input type="text" placeholder="<请输入你的微信>" v-model="wx">
						</div>
					</div>
				</div>
			</div>
			<div class="btn">
				<button @click="next">下一步</button>
			</div>
			<div class="a-box">
				<a href="https://www.zoujindama.com/">返回官网</a>
			</div>
			<div class="about">
				<div class="title">走进大马:</div>
				<p>1、帮大马的好产品打开中国市场</p>
				<p>2、助中国的好项目落地马来西亚</p>
				<p>3、教大马伙伴如何在中国做生意</p>
				<p>4、深耕马来西亚九年</p>
				<p>5、精通两地企业服务、资源对接及供应链整合</p>
				<p>6、只做两地精品、只讲有用干货</p>
				<p>7、合作手机/微信：17895000146</p>
			</div>
			<div class="bottom-img">
				<img src="../assets/img/form-img.png" alt="">
			</div>
		</section>
	</div>
</template>

<script>
	import Header from '../components/common/Header.vue'
	import Vue from 'vue'
	import {
		RadioGroup,
		Radio
	} from 'vant';
	import {
		Button
	} from 'vant';
	import {
		Toast
	} from 'vant';

	Vue.use(Toast);
	Vue.use(Button);
	Vue.use(Radio);
	Vue.use(RadioGroup);
	export default {
		data() {
			return {
				radio: '2', //单选框 1中国，2马来
				name: '', //姓名,
				phone: '', //手机号
				wx: '', //微信号
			}
		},
		mounted() {
			console.log(123)
		},
		methods: {
			selectRadio(e) {
				console.log(e)
			},
			//点击下一步
			next() {
				// if (this.name === '' & !/^[\u4e00-\u9fa5]{0,}$/.test(this.name)) {
				// 	Toast.fail('请输入正确的姓名');
				// 	return
				// } else if (!/^.{2,4}$/.test(this.name)) {
				// 	Toast.fail('请输入正确的姓名格式！')
				// 	return
				// }
				if (this.name === '') {
					Toast.fail('请输入姓名');
					return
				}
				if (this.wx === '') {
					Toast.fail('请输入微信');
					return
				}
				if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.phone)) {
					Toast({
						message: "请填写正确的手机号",
						type: "fail"
					});
					return
				}
				if (this.phone === '') {
					Toast.fail('请输入手机号');
					return
				}
				let data = {
					type: this.radio,
					name: this.name,
					phone: this.phone,
					wx: this.wx
				}
				this.$router.push({
					path: '/form',
					query: {
						data
					}
				})
			}
		},
		created() {},
		components: {
			Header
		}
	}
</script>

<style scoped="scoped" lang="less">
	.main {
		width: 100vw;
		height: 100vh;

		.main-content {
			width: 100%;
		}
	}

	.main-content {
		width: 100%;

		h1,
		h2 {
			width: 100%;
			text-align: center;
		}

		h1 {
			font-size: 24px;
		}

		h2 {
			margin-top: 4px;
			color: #737373;
		}

		.bottom-img {
			margin-top: 30px;
			width: 100%;

			img {
				width: 100%;
			}
		}

		.about {
			margin-top: 20px;
			padding: 0 30px;
			color: #B4B4B4;

			p {
				padding: 2px 0;
			}
		}

		.a-box {
			margin-top: 20px;
			padding: 0 30px;
			text-align: center;

			a {
				box-sizing: border-box;
				border:2px solid #DC394A;
				color: #DC394A;
				width: 100%;
				padding: 10px 0;
				border-radius: 7px;
				font-size: 16px;
				display: block;
			}
		}

		.btn {
			padding: 0 30px;
			text-align: center;

			button {
				box-sizing: border-box;
				background-color: #DC394A;
				color: #FFFFFF;
				width: 100%;
				padding: 13px 0;
				border-radius: 7px;
				font-size: 16px;
			}
		}

		.content-form {
			width: 100%;
			box-sizing: border-box;
			padding: 15px;

			.form-box {
				box-sizing: border-box;
				background-color: #F2F2F2;
				padding: 10px 15px;

				.form-box_item {
					padding: 15px 0;
					display: flex;
					align-items: center;
					font-size: 13px;
					color: #343434;

					.item-left {
						width: 45%;
						text-align: right;
					}

					.item-right {
						margin-left: 10px;
						padding: 5px;
						flex: 1;
						background-color: #FFFFFF;

						input::-webkit-input-placeholder {
							font-size: 12px;
							color: #D2CBCC;
						}
					}
				}
			}
		}

		.content-radio {
			margin-top: 22px;
			width: 100%;
			box-sizing: border-box;
			padding: 0 30px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.radio-item {
				display: flex;
				align-items: center;

				.text {
					margin-left: 10px;
					font-size: 0.373333rem;
				}
			}
		}
	}
</style>
